module.exports = __webpack_public_path__ + "static/drag_and_drop_email@2x.daffff3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/engagement/drag_and_drop_email@2x.png
// module id = 216
// module chunks = 193162123475590 216210090109534